import { createAnswerSchema } from '../answerSchemaFields';
import {
  createQuestionSchema,
  questionAutoCommit,
  questionInstantStatistic,
  questionRequiresAnswer,
} from '../questionSchemaFields';
import { config } from './BinaryPoll.config';

export const schema = createQuestionSchema(
  {
    type: 'object',
    properties: {
      type: { enum: [config.name] },
      answers: {
        type: 'array',
        items: createAnswerSchema(),
      },
    },
    required: ['answers', 'type'],
  },
  questionAutoCommit,
  questionRequiresAnswer,
  questionInstantStatistic,
);
